module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAIxJREFUOBHtUkEKgDAM68Tv+BofpB/yNd70MbXDpZRRhogylHlplqZZFyT65cfMGx5mMbjbVcwYwxaD82rnkU9wzVhTrBOF/AGzrpCBUi9Ke6sX8SDn0XCTcOZ4wmSa95YQwgrxa1HgAremzUiqrg2Mnjt4lYRZ1Ftcmn8timassVePYtdViCw29NfhAViEPtTNmumJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_WidthMin_normal.png
// module id = 325
// module chunks = 0